/**
 * Batas dan validasi upload file untuk seluruh aplikasi.
 *
 * Nilainya harus sama dengan MAX_UPLOAD_BYTES di backend
 * (apps/middleware/utilities/storage.js). Bila ingin diubah tanpa build ulang,
 * gunakan environment variable REACT_APP_MAX_UPLOAD_MB.
 */

export const MAX_UPLOAD_MB = Number(process.env.REACT_APP_MAX_UPLOAD_MB || 100);
export const MAX_UPLOAD_BYTES = MAX_UPLOAD_MB * 1024 * 1024;

export const MIME_PDF = 'application/pdf';
export const MIME_XLS = 'application/vnd.ms-excel';
export const MIME_XLSX =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const DOCUMENT_MIME_TYPES = [MIME_PDF, MIME_XLS, MIME_XLSX];
export const PDF_ONLY_MIME_TYPES = [MIME_PDF];

export const DOCUMENT_MIME_LABEL = 'PDF (.pdf) atau Excel (.xls/.xlsx)';
export const PDF_ONLY_MIME_LABEL = 'PDF (.pdf)';

export const formatFileSize = (bytes) => {
  if (!Number.isFinite(bytes) || bytes < 0) return '-';
  const units = ['B', 'KB', 'MB', 'GB'];
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${value.toFixed(value >= 10 || unit === 0 ? 0 : 1)} ${units[unit]}`;
};

/**
 * Memeriksa file pilihan user sebelum dibaca menjadi base64.
 * Mengembalikan null bila valid, atau { title, text } bila ditolak.
 */
export const validateUploadFile = (
  file,
  {
    allowedMimeTypes = DOCUMENT_MIME_TYPES,
    allowedLabel = DOCUMENT_MIME_LABEL,
  } = {}
) => {
  if (!file) {
    return {
      title: 'File Belum Dipilih',
      text: `Silakan pilih file berformat ${allowedLabel} terlebih dahulu.`,
    };
  }

  if (allowedMimeTypes.length && !allowedMimeTypes.includes(file.type)) {
    return {
      title: 'Format File Tidak Sesuai',
      text: `File dokumen hanya boleh berformat ${allowedLabel}.`,
    };
  }

  if (file.size === 0) {
    return {
      title: 'File Kosong',
      text: 'File yang dipilih berukuran 0 byte. Silakan pilih file lain.',
    };
  }

  if (file.size > MAX_UPLOAD_BYTES) {
    return {
      title: 'Ukuran File Terlalu Besar',
      text:
        `Ukuran file ${formatFileSize(file.size)} melebihi batas maksimal ` +
        `${MAX_UPLOAD_MB} MB. Silakan kompres file atau bagi menjadi beberapa dokumen.`,
    };
  }

  return null;
};
